export const encodeParams = (data = {}, skipEmpty = true) => {
  return Object.keys(data).map(function (key) {
    if (!(isEmpty(data[key]) && skipEmpty)) {
      return [key, data[key]].map(encodeURIComponent).join('=')
    }

    /*
    if ((typeof data[key] !== 'undefined')) {
      if (!skipEmpty || (data[key] !== '')) {

      }
    }
    */
  }).filter(entry => entry).join('&')
}

const isEmpty = (value) => ((typeof value === 'undefined') || (value === null) || (value === ''))
